export default {
  // evaluable_type
  TYPE_POST: "Post",
  TYPE_COMMENT: "Comment",
};
